import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';

import {
    LOADING,
    LOAD_PROMOTION_PROVIDERS_SUCCESS,
    LOAD_SELECTED_PROMO_PROVIDER_SUCCESS,
    TOGGLE_CHAIN_LEVEL_PROMOTION_SETTINGS
} from '../types';
import MessageUtils from '../../utils/MessageUtils';

export const getPromotionProviders = () => {
    return (dispatch) => {

        const url = `/promotion-partner`;

        axios().get(url)
            .then(res => dispatch({ type: LOAD_PROMOTION_PROVIDERS_SUCCESS, payload: res.data }))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data));
    }
}

export const getBrandLevelPromoProvider = (id) => {
    return (dispatch) => {

        const url = `/restaurant-chain/${id}/promotion-partner-settings`;

        axios().get(url)
            .then(res => dispatch({ type: LOAD_SELECTED_PROMO_PROVIDER_SUCCESS, payload: res.data }))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data));
    }
}

export const updateBrandLevelPromoProviderSettings = (id, promoProvider) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-chain/${id}/promotion-partner-settings`;

        let settings = {
            type: {
                id: +promoProvider.type.id
            },
            settings: typeof promoProvider.settings !== 'string' ? JSON.stringify(promoProvider.settings) : promoProvider.settings
        };

        axios().put(url, settings)
            .then(_ => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promoProvidersActions.savedSuccess'));
            })
            .catch(err => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, err.response.data);
            });
    }
}

export const getRestaurantLevelPromoProvider = (id) => {
    return (dispatch) => {

        const url = `/restaurant/${id}/promotion-partner-settings`;

        axios().get(url)
            .then(res => {
                dispatch({ type: LOAD_SELECTED_PROMO_PROVIDER_SUCCESS, payload: res.data });
            })
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data));
    }
}

export const updateRestaurantLevelPromoProviderSettings = (id, promoProvider) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${id}/promotion-partner-settings`;

        let settings = {
            type: {
                id: +promoProvider.type.id
            },
            settings: typeof promoProvider.settings !== 'string' ? JSON.stringify(promoProvider.settings) : promoProvider.settings
        };

        axios().put(url, settings)
            .then(_ => {
                dispatch(getRestaurantLevelPromoProvider(id));
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promoProvidersActions.savedSuccess'));
            })
            .catch(err => {

                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, err.response.data);
            });
    }
}

export const changeChainLevelPromotionSettings = (callback) => {
    return (dispatch, getState) => {

        const prevChainLevelPromotionSettings = getState().brand.chainLevelPromotionSettings;

        dispatch({ type: TOGGLE_CHAIN_LEVEL_PROMOTION_SETTINGS, payload: !prevChainLevelPromotionSettings });

        const state = {
            brand: getState().brand,
            admin: getState().brand.admin,
            manager: getState().brand.manager
        }

        if (callback) {
            setTimeout(() => callback(state), 100);
        }
    };
};


// WEBPACK FOOTER //
// ./src/actions/promotionProviders/PromotionProvidersActions.js